// extracted by mini-css-extract-plugin
module.exports = {"educationSectionContainer":"-p3ovgp_","educationData":"_29Vwu57m","companyDelimiter":"_1IZYh7Sh","centered":"_2AsiqYzm"};
    if(module.hot) {
      // 1746735833334
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  